import { Ability } from '@casl/ability'

import { IPage, Permission } from './RouteAuthWrapper'

/**
 *
 * @param array
 * @param fn
 * @returns
 */
export function pagesFilter(array: Array<Partial<IPage>>, fn: (page: Partial<IPage>) => boolean) {
  return array.reduce((r: Array<Partial<IPage>>, o: Partial<IPage>) => {
    const pages = pagesFilter(o.pages || [], fn)
    if (fn(o) === true) {
      r.push(Object.assign({}, o, pages.length && { pages }))
    }
    return r
  }, [])
}

/**
 *
 * @param array
 * @param key
 * @param value
 * @returns
 */
export function getObject(array: Array<Partial<IPage>>, key: keyof IPage, value: unknown) {
  let o
  array.some(function iter(a) {
    if (a[key] === value) {
      o = a
      return true
    }
    return Array.isArray(a.pages) && a.pages.some(iter)
  })
  return o
}

/**
 *
 * @param ability
 * @param permissions
 * @returns
 */
export function userHasPermissions(ability: Ability, permissions: Permission[]): boolean {
  return permissions.every((permission) => userHasPermission(ability, permission))
}

/**
 *
 */
export function userHasAtLeastOnePermission(ability: Ability, permissions: Permission[]): boolean {
  return permissions.length > 0 ? permissions.some((permission) => userHasPermission(ability, permission)) : true
}

/**
 *
 * @param ability
 * @param permission
 * @returns
 */
export function userHasPermission(ability: Ability, permission: Permission): boolean {
  const [action, subject] = permission
  return ability.can(action, subject)
}
